import { BrowserRouter as Router, Route, Routes } from "react-router";
import { LP_AFFILIATOR, USERS_AFFILIATOR } from "./routes";
import ProvideLoggedInUser from "./providers/ProvideLoggedInUser";
import ProvideLandingSearch from "./providers/ProvideLandingSearch";
import AffiliatorsPage from "./affiliators/App";
import UsersAffiliatorsPage from "./users/affiliators/App";

const UnnamedComponent = (props) => {
  let ret = (
    <Routes>
      <Route caseSensitive path={LP_AFFILIATOR} element={<AffiliatorsPage />} />
      <Route
        caseSensitive
        path={USERS_AFFILIATOR}
        element={<UsersAffiliatorsPage />}
      />
    </Routes>
  );
  ret = <Router children={ret} />;
  ret = <ProvideLoggedInUser children={ret} />;
  ret = <ProvideLandingSearch children={ret} />;

  return ret;
};

export default UnnamedComponent;
